import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext, StateToken} from '@ngxs/store';
import {throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {Transaccion} from "../models/transaccion.model";
import {
  CreateTransaccionAction,
  GetTransaccionAction,
  GetTransaccionListAction,
  ResetTransaccionListFilter,
  SearchTransaccionListAction
} from '../actions/transaccion.actions';
import {TransaccionApiService} from "../api/transaccion.api.service";
import {Constants} from "../util/constants";
import {TransaccionListFilter} from "../models/transaccion-list-filter.model";
import {PageableApiResult} from "../models/pagable-api-result.model";
import {DateFilter} from "../models/date-filter.model";
import {DateTime} from "luxon";

export interface TransaccionStateModel {
  transaccionList: Transaccion[],
  transaccion: Transaccion,
  transaccionListFilter: TransaccionListFilter,
  transaccionPage: PageableApiResult<Transaccion>,
}

const initialState: TransaccionStateModel = {
  transaccionList: null,
  transaccion: null,
  transaccionListFilter:null,
  transaccionPage:null
};

const TRANSACCION_STATE_TOKEN = new StateToken<TransaccionStateModel>('transaccion');

@State<TransaccionStateModel>({
  name: TRANSACCION_STATE_TOKEN,
  defaults: initialState
})
@Injectable()
export class TransaccionState {

  constructor(
    private transaccionApiService: TransaccionApiService
  ) {
  }

  @Action(GetTransaccionListAction)
  handleGetTransaccionListAction(ctx: StateContext<TransaccionStateModel>, action: GetTransaccionListAction) {

    ctx.patchState({
      transaccionList: null
    })

    return this.transaccionApiService.getTransaccionList().pipe(
      tap(transaccionList => {
        const state = ctx.getState();

        ctx.patchState({
          transaccionList
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(GetTransaccionAction)
  handleGetTransaccionAction(ctx: StateContext<TransaccionStateModel>, action: GetTransaccionAction) {

    const {transaccionId} = action.payload;


    return this.transaccionApiService.getTransaccion(transaccionId).pipe(
      tap(transaccion => {
        const state = ctx.getState();

        ctx.patchState({
          transaccion
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(CreateTransaccionAction)
  handleCreateTransaccionAction(ctx: StateContext<TransaccionStateModel>, action:CreateTransaccionAction) {

    const {importe, userReceiverId} = action.payload;

    ctx.patchState({
      transaccion:null
    })

    return this.transaccionApiService.createTransaccion(importe, userReceiverId).pipe(
      tap(createdTransaccion => {
        const state = ctx.getState();

        // ctx.patchState({
        //   transaccion:createdTransaccion,
        //   bankList:[state.bankList,createdBank]
        // })

      }),
      catchError(err => {
        return throwError(err)
      })
    );

  }

  @Action(SearchTransaccionListAction)
  handleSearchTransaccionListAction(ctx: StateContext<TransaccionStateModel>, action: SearchTransaccionListAction) {
    // Check for status options in state

    const filter = ctx.getState()?.transaccionListFilter;
    const actionFilter = action.payload?.filter

    const defaultDateFilter:DateFilter = {
      from:DateTime.fromObject({day:1,month:1,year:2022}).toJSDate().toISOString()
    }

    let reqFilter: TransaccionListFilter

    if (filter) {
      reqFilter = {
        ...filter,
        ...actionFilter
      }

    } else {
      //filtros por defecto:
      reqFilter = {
        page: 0,
        size: Constants.PAGE_SIZE,
        dateFilter: (actionFilter?.dateFilter)||defaultDateFilter
      }
    }

    ctx.patchState({
      transaccionListFilter: reqFilter
    })

    return this.transaccionApiService.searchTransaccionList(reqFilter).pipe(
      tap(transaccionPage => {
        ctx.patchState({
          transaccionPage
        })
      })
    )
  }
  @Action(ResetTransaccionListFilter)
  handleResetTransaccionListFilter(ctx: StateContext<TransaccionStateModel>, action: ResetTransaccionListFilter): void {
    ctx.patchState({
      transaccionListFilter: {
        dateFilter : {
          from: DateTime.fromObject({day:1,month:1,year:2022}).toJSDate().toISOString(),
          to: '',
        },
      }
    });
  }

  @Selector()
  static getTransaccionList(state: TransaccionStateModel): Transaccion[] {
    return state?.transaccionList
  }

  @Selector()
  static getTransaccion(state: TransaccionStateModel) {
    return state?.transaccion
  }

  @Selector()
  static getTransaccionPage(state: TransaccionStateModel): PageableApiResult<Transaccion> {
    return state?.transaccionPage
  }
  @Selector()
  static getTransaccionListFilter(state: TransaccionStateModel): TransaccionListFilter {
    return state?.transaccionListFilter;
  }
}
